module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/102bfa6b6978940ca3d8d942e3b31097.svg";